export default "__VITE_ASSET__BiEnnqbS__"